import { t } from "i18next";
import CustomCarousel from "../../helpers/customCarousel";
import CustomModalPlus from "../../helpers/customModalPlus";
import { useEffect, useState, lazy } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import ComparisonOffer from "../Comparison offer";
import { addLineBreaks } from "../../../utils";
import logFirebaseEvents from "../../../components/LogFirebaseEvents";
import Loader from "../../../components/CustomComponents/Loader";
import { appTheme } from "../../../helpers/utils/Utils";
import { PAID_PROMO_KEY } from "../../../network/URLConstants";
import Cookies from "js-cookie";
import { getUserMembership } from "../../../helpers/utils/Utils";
import { retrieveData } from "../../../helpers/utils/Utils";
import { GetApiHeadersWithBearer } from "../../../network/NetworkUtils";
import { PROGRAM_CONTENT } from "../../../network/URLConstants";
import { GetRequest } from "../../../network/NetworkUtils";
import { STATUS_SUCCESS_CODE } from "../../../network/URLConstants";
import { Suspense } from "react";
const MemnershipEnrollmentScreens = ({ isSignUpAccept, isSignUpCancel, extendFlowCloseCallbackFunction, expiredFlow }) => {
  const SignUpKudzuplusTrue = useSelector(state => state.isSignUpKudzuplusTrueData);
  const isSignUpKudzuplusTrialVal = useSelector(state => state.isSignUpKudzuplusTrial);
  // alert(SignUpKudzuplusTrue+"SignUpKudzuplusTrue");
  const [highlightMsg, setHighlightMsg] = useState("");
  const [headerMsg, setheaderMsg] = useState("");
  const [subHeaderMsg, setSubHeaderMsg] = useState("");
  const [btn1Exists, setBtn1Exists] = useState(false);
  const [btn2Exists, setBtn2Exists] = useState(false);
  const [policyURL, setPolicyURL] = useState("");
  const [btn1Text, setBtn1Text] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [btn2Text, setBtn2Text] = useState("");
  const [modelImage, setModelImage] = useState("");
  const [carousel, setCarousel] = useState('');
  const [comparisonScreen, setComparisonScreen] = useState('');
  const [summaryParagraph, setSummaryParagraph] = useState('');
  const [btn1TypeAcpt, setBtn1TypeAcpt] = useState(false);
  const [footerMsg, setFooterMsg] = useState("");
  const [btn1Focus, setBtn1Focus] = useState(false);
  const [btn2Focus, setBtn2Focus] = useState(false);
  const [modalBg, setModalBg] = useState("");
  const [btn1TextColor, setBtn1TextColor] = useState("");
  const [btn1BrExist, setBtn1BrExist] = useState(false);
  const [btn2TextColor, setBtn2TextColor] = useState("");
  const [btn1BgColor, setBtn1BgColor] = useState("");
  const [btn1BorderColor, setBtn1BorderColor] = useState("");
  const [quickActions, setQuickActions] = useState(true);
  const [isBorderNone, setisBorderNone] = useState(true);
  const [opacityValueLow, setOpacityValueLow] = useState(true);
  const [gradientButton, setGradientButton] = useState(false);
  const [gradientButtonBackground, setGradientButtonBackground] = useState(false);
  const [largeImage, setLargeImage] = useState(false);
  const [kudzuCheck, setKudzuCheck] = useState(false);
  const loggedResponse = useSelector(state => JSON.parse(state.loggedInResponse));
  const userMembershipData = getUserMembership(loggedResponse)
  const Modal = lazy(() => import("../../../components/CustomComponents/Modal"));

  const kudzuPlusModalValue = useSelector(state => state.kudzuPlusModal);
  const cardDetails = useSelector(state => state.selectedCardDetails);

  const [showAgreementsModel, setShowAgreementsModel] = useState(false);
  const [showPlusModal, setShowPlusModal] = useState(kudzuPlusModalValue);
  const [fullWidth, setFullWidth] = useState(false);
  const [footerButtonEnable, setFooterButtonEnable] = useState(false);
  const [allButtonsDisable, setAllButtonsDisable] = useState(false);
  const [loading, setLoading] = useState(false)

  const [promoKey, setPromoKey] = useState(loggedResponse?.Promos?.[0]?.PromoKey);
  const signUpkudzuisTrialTrue = useSelector(state => state.isSignUpKudzuplusTrial);
  const accessTokenToApi = useSelector((state) => state.accessToken);
  const cards = useSelector(state => JSON.parse(state.userCards));
  const [showToolTip, setShowToolTip] = useState(true);
  const [subHeadingForCarousel, setSubHeadingForCarousel] = useState('')
  const SubHeaderMsgStylesPlus = "font-hanken-grotesk modal-title  md:text-[18px] sm:text-[14px] text-[16px] font-normal cursor-pointer text-white";
  const HighlightMsgStylesPlus = "font-hanken-grotesk modal-title  md:text-[18px] sm:text-[14px] text-[16px] font-normal cursor-pointer text-[#94C3E8]";


  const navigate = useNavigate()
  const dispatch = useDispatch()
  const location = useLocation()


  const HighlightMsgStyles =
    "sm:w-auto w-[253px] font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-normal text-[#2965FB] cursor-pointer pointer-events-none";
  const HeaderMsgStyles = "font-serif-pro modal-title text-white lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-[400] cursor-pointer pointer-events-none";
  const SubHeaderMsgStyles = "font-hanken-grotesk modal-title lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] font-normal cursor-pointer pointer-events-none";
  const summaryParagraphStyles =
    "font-hanken-grotesk modal-title text-white lg:text-[16px] md:text-[15px] sm:text-[12px] text-[16px] font-normal cursor-pointer pointer-events-none";

  const kudzuFlowFromVal = useSelector(state => state.kudzuFlowFrom);
  const climbPopShowValue = useSelector(state => state.climbPopShowValue);

  const getAgreementsBasedOnType = async (selectedAgreementType) => {
    const deviceId = await retrieveData("updatedDeviceId");
    const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
    setLoading(true);

    let finalUrl =
      PROGRAM_CONTENT +
      "?accountType=64&language=en&contentType=" +
      selectedAgreementType +
      "&programKey=200";
    var response = await GetRequest(finalUrl, headers);
    var responseObj = JSON.parse(response);
    setLoading(false);
    if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {
      setPolicyURL(responseObj.Response.Data);
     
    } else {
      setTimeout(() => {
        var arrMessages = responseObj.Messages;
        var message = arrMessages[0];
        var displayText = message.DisplayText;
        // setError(displayText)
      }, 500);
    }
  };

  const handlePreLoginAgreement = async () => {
       setShowPlusModal(false)
       await getAgreementsBasedOnType("CoveredByKudzuPlusTerms");
       setShowAgreementsModel(true)
  }
  const handleTermsClick = async () => {
    if (accessTokenToApi == undefined || accessTokenToApi == null) {
     
   setShowPlusModal(false)
   await getAgreementsBasedOnType("CoveredByKudzuPlusTerms");
   setShowAgreementsModel(true)
    }
    else {
      navigate('/Documents/Policies/Covered%20by%20Kudzu%20Terms%20and%20Conditions', {
        state: {
          name: 'Covered by Kudzu Terms and Conditions',
          url: "CoveredByKudzuPlusTerms"
          , accType: 64, CardKey: cards?.[0]?.CardKey
        }
      });

    }
  }



  const slidesDataForHome = [
    {
      heading: t("Receive_Direct_Deposits"),
      paragraph: (t("Direct_deposit_funds")),
      videoUrl: require('./../../../assets/videos/freeTrailVideos/kudzu-plus-ach.mp4'),
      footerTextForUpgrade: t("new_footer_signup_carousel_receive"),
      dynamicfooterStyles: "font-hanken-grotesk md:w-[454px] mt-[42px] modal-title text-[#94C3E8] text-[12px] font-[400] sm:w-[322px]"
    },

    {
      heading: addLineBreaks(t("heading_saving_goals")),
      paragraph: <p>
        {t("plan_future_para")}
        <span
          className="!text-[#94C3E8] lg:text-[17px] cursor-pointer relative inline-block"
          onClick={(e) => {
            e.stopPropagation();
            const tooltip = e.currentTarget.querySelector('.tooltip');
            if (!tooltip) return;

            const isVisible = tooltip.style.display === 'block';
            tooltip.style.display = isVisible ? 'none' : 'block';

            // Close the second tooltip if it's open
            const tooltipAPY = e.currentTarget.closest('p').querySelector('.tooltipAPY');
            if (tooltipAPY && tooltipAPY.style.display === 'block') {
              tooltipAPY.style.display = 'none';
            }

            if (!isVisible) {
              const handleClickOutside = (event) => {
                if (tooltip && !tooltip.contains(event.target)) {
                  tooltip.style.display = 'none';
                  document.removeEventListener('click', handleClickOutside);
                }
              };
              setTimeout(() => {
                document.addEventListener('click', handleClickOutside);
              }, 0);
            }
          }}
        >
          {addLineBreaks(t("Saving"))}
          <div
            className={`tooltip hidden w-[174px] font-[400] absolute left-1/2 -translate-x-1/2 top-[100%] mt-2
            p-[16px] bg-[#3C66FF] text-white text-[12px] rounded-xl
            shadow-lg z-10 cursor-pointer transition-all duration-1000`}
          >
            <div className="tooltip-arrow-comparion"></div>
            <span className="text-[14px]">{t('Savings_Goals')}</span> {t('SavingGoal_Tooltip')}
          </div>
        </span>{" "}
        <br></br>
        <span
          className="!text-[#94C3E8] lg:text-[17px] cursor-pointer relative inline-block"
        >
          {addLineBreaks(t("Goal"))}
          <div
            className={`tooltip hidden w-[174px] font-[400] absolute left-1/2 -translate-x-1/2 top-[100%] mt-2
            p-[16px] bg-[#3C66FF] text-white text-[12px] rounded-xl
            shadow-lg z-10 cursor-pointer transition-all duration-1000`}
          >
            <div className="tooltip-arrow-comparion"></div>
            <span className="text-[14px]">{t('Savings_Goals')}</span> {t('SavingGoal_Tooltip')}
          </div>
        </span>{" "}
        {t("para_saving_goals_sec_part")}{" "}
        <span
          className="!text-[#94C3E8] cursor-pointer relative inline-block"
          onClick={(e) => {
            e.stopPropagation();
            const tooltips = e.currentTarget.querySelector('.tooltipAPY');
            if (!tooltips) return;

            const isVisibleAPY = tooltips.style.display === 'block';
            tooltips.style.display = isVisibleAPY ? 'none' : 'block';

            // Close the first tooltip if it's open
            const tooltip = e.currentTarget.closest('p').querySelector('.tooltip');
            if (tooltip && tooltip.style.display === 'block') {
              tooltip.style.display = 'none';
            }

            if (!isVisibleAPY) {
              const handleClickOutside = (event) => {
                if (tooltips && !tooltips.contains(event.target)) {
                  tooltips.style.display = 'none';
                  document.removeEventListener('click', handleClickOutside);
                }
              };
              setTimeout(() => {
                document.addEventListener('click', handleClickOutside);
              }, 0);
            }
          }}
        >
          {t("para_saving_goals_third_part")}
          <div
            className={`tooltipAPY hidden w-[174px] font-[400] absolute left-1/2 -translate-x-1/2 top-[100%] mt-2
            p-[16px] bg-[#3C66FF] text-white text-[12px] rounded-xl
            shadow-lg z-10 cursor-pointer transition-all duration-1000`}
          >
            <div className="tooltip-arrow-comparion"></div>
            <strong className="text-[12px]">{t('APY')}</strong> {t('APY_Saving_goal')}
          </div>
        </span>
      </p>
      ,
      videoUrl: require('./../../../assets/videos/freeTrailVideos/Set_Intentions.mp4'),
      footerTextForUpgrade: <p className="text-[#94C3E8] pt-14  lg:text-[12px] md:text-[14px] "> {t("footer_saving_goals")}</p>,
      dynamicSubHeaderStyles: "sm:w-[450px] font-hanken-grotesk modal-title text-white lg:text-[17px] md:text-[14px] sm:text-[10px] text-[12px] mt-4  font-[300]",
    },
    //need to change
    {
      heading: addLineBreaks(t("Enable_Overdraft_Protection")),
      paragraph: <p>{t("enable_over_draft_para_trail")}</p>,
      imageUrlAlter: require('./../../../assets/kudzu-plus-images/overdraft_imag.png'),
      footerTextForUpgrade: <>{t("enabled_overdraft_updated_footer")} <span className="underline cursor-pointer" onClick={handleTermsClick}>{t('kudzu_navigate_link')}</span></>,
      dynamicfooterStyles: "font-hanken-grotesk md:w-[454px] mt-[42px] modal-title text-[#94C3E8] text-[12px] font-[400] sm:w-[322px]"
    },
    {
      heading: addLineBreaks(t("Save_On_Out_Of_NetWork_Atm")),
      paragraph: (t('We_wont_charge_on_ATM')),
      videoUrl: require('./../../../assets/videos/freeTrailVideos/kudzu-plus-atm.mp4'),
      footerTextForUpgrade: t("free_atm_footer"),
      dynamicfooterStyles: "font-hanken-grotesk mt-[50px] modal-title text-[#94C3E8] text-[12px] font-[400] pb-12"
    },
  ];
  const slidesDataForHomeExample = [
    {
      heading: t("Receive_Direct_Deposits"),
      paragraph: addLineBreaks(t("Direct_deposit_funds")),
      // imageUrl: require('./../../../assets/kudzu-plus-images/LearnMoreCarouselTrail/new-gif/kudzu-plus-cbk.png')
    },
    {
      heading: addLineBreaks(t("Unlock_Higher_Interest_on_Savings")),
      paragraph: addLineBreaks(t("Earn_1.25%_Annual_Percentage")),
      videoUrl: require('./../../../assets/videos/freeTrailVideos/Savings_APY.mp4')
    },
    {
      heading: addLineBreaks(t("Enable_Overdraft_Protection")),
      paragraph: <p>{t("We’ve_got_you_covered_up_to_$100")} <span className='text-[#94C3E8] cursor-pointer'>{t("here")}</span> </p>,
      imageUrl: require('./../../../assets/kudzu-plus-images/LearnMoreCarouselTrail/Enable_Overdraft_Protection.png')
    },
    {
      heading: addLineBreaks(t("Set_Intentions_with_Savings _Goals")),
      paragraph: addLineBreaks(t("Prioritize_saving_toward_unique_goals")),
      imageUrl: require('./../../../assets/kudzu-plus-images/LearnMoreCarouselTrail/Set _Intentions.png')
    },
    {
      heading: addLineBreaks(t("Enjoy_Fee-Free_ATM_Withdrawals")),
      paragraph: addLineBreaks(t('Withdraw_funds_from_any_out-of-network_ATM_totally_fee-free')),
      imageUrl: require('./../../../assets/kudzu-plus-images/LearnMoreCarouselTrail/Enjoy_Fee-Free_ATM.png')
    },
  ];

  const slidesDataForClimb = [
    {
      heading: addLineBreaks(t("Stay_covered_for_up_to_$100_when_you_need_it")),
      paragraph: <p className="">{t("Review_the_full_terms_here")} <span className='text-[#94C3E8] cursor-pointer ' onClick={() => { handleTermsClick() }}>{t("here")}</span>.</p>,
      imageUrl: require('./../../../assets/kudzu-plus-images/overdraft_imag.png'),
      footerText: (
        <>
          <p>
            {(() => {
              const text = t("enabled_overdraft_updated_footer");
              const lines = text.split("\n");
              const lastLine = lines.pop(); // Remove the last line to handle separately
              const remainingText = lines.join("\n"); // Join the remaining lines back with \n

              return (
                <>
                  {addLineBreaks(remainingText)}
                  {lastLine}{" "}
                  <span className="underline cursor-pointer" onClick={handleTermsClick}>
                    {t("kudzu_navigate_link")}
                  </span>
                </>
              );
            })()}
          </p>
        </>
      ),
      dynamicfooterStyles: "font-hanken-grotesk md:w-[454px] mt-[42px]  modal-title text-[#94C3E8] text-[11px] font-[400] sm:w-[322px] px-1",
      slackListHeight: "675px"

    },
    {
      heading: addLineBreaks(t("set_intention_climb_header")),
      paragraph: <p className="lg:text-[14px]">{t("plan_future_para")}
        <span className="!text-[#94C3E8] cursor-pointer relative inline-block"
          onClick={(e) => {
            e.stopPropagation();
            const tooltip = e.currentTarget.querySelector('.tooltip');
            if (!tooltip) return;

            const isVisible = tooltip.style.display === 'block';
            tooltip.style.display = isVisible ? 'none' : 'block';

            // Close the second tooltip if it's open
            const tooltipAPY = e.currentTarget.closest('p').querySelector('.tooltipAPY');
            if (tooltipAPY && tooltipAPY.style.display === 'block') {
              tooltipAPY.style.display = 'none';
            }

            if (!isVisible) {
              const handleClickOutside = (event) => {
                if (tooltip && !tooltip.contains(event.target)) {
                  tooltip.style.display = 'none';
                  document.removeEventListener('click', handleClickOutside);
                }
              };
              setTimeout(() => {
                document.addEventListener('click', handleClickOutside);
              }, 0);
            }
          }}
        >
          {t("para_saving_goals")}
          <div
            className={`tooltip hidden w-[174px] font-[400] absolute left-1/2 -translate-x-1/2 top-[100%] mt-2
            p-[16px] bg-[#3C66FF] text-white text-[12px] rounded-xl
            shadow-lg z-10 cursor-pointer transition-all duration-1000`}
          >
            <div className="tooltip-arrow-comparion"></div>
            <span className="text-[14px]">{t('Savings_Goals')}</span> {t('SavingGoal_Tooltip')}
          </div>
        </span>
        {" "}{t("para_saving_goals_sec_part")}{" "}
        <span className="!text-[#94C3E8] cursor-pointer relative"
          onClick={(e) => {
            e.stopPropagation();
            const tooltips = e.currentTarget.querySelector('.tooltipAPY');
            if (!tooltips) return;

            const isVisibleAPY = tooltips.style.display === 'block';
            tooltips.style.display = isVisibleAPY ? 'none' : 'block';

            // Close the first tooltip if it's open
            const tooltip = e.currentTarget.closest('p').querySelector('.tooltip');
            if (tooltip && tooltip.style.display === 'block') {
              tooltip.style.display = 'none';
            }

            if (!isVisibleAPY) {
              const handleClickOutside = (event) => {
                if (tooltips && !tooltips.contains(event.target)) {
                  tooltips.style.display = 'none';
                  document.removeEventListener('click', handleClickOutside);
                }
              };
              setTimeout(() => {
                document.addEventListener('click', handleClickOutside);
              }, 0);
            }
          }}
        >
          {t("para_saving_goals_third_part")}
          <div
            className={`tooltipAPY hidden  w-[174px] font-[400] absolute left-1/2 -translate-x-[40%] top-[100%] mt-0
            p-[16px] bg-[#3C66FF] text-white text-[12px] rounded-xl
            shadow-lg z-10 cursor-pointer transition-all duration-1000`}
          >
            <div className="tooltip-arrow-comparion"></div>
            <strong className="text-[12px]">{t('APY')}</strong> {t('APY_Saving_goal')}
          </div>
        </span></p>,
      footerText: <p className="mt-12">{t("set_intentions_welcome_footer")}</p>,
      dynamicfooterStyles: "font-hanken-grotesk mb-[10%] modal-title text-[#94C3E8] text-[12px] font-[400] ",
      videoUrl: require('./../../../assets/videos/freeTrailVideos/Set_Intentions.mp4'),
      slackListHeight: "675px"
    },
    {
      heading: t("And_Even_More_Kudzu+_Perks"),
      paragraph: <p className="lg:text-[13px] mb-10">{addLineBreaks((t('Unlock_a_higher_interes_savings_Annual_Percentage_Yield_(APY)')))}</p>,
      imageUrl: require('./../../../assets/kudzu-plus-images/welcom-carousel/And-Even-More.png'),
      footerText: <div className='flex flex-col gap-4'>
        <p className='!w-[433px] !text-[11px]'>{t("even_perks_welcome_carousel_paraOne")}</p>
        <p className='!text-[11px]'>{t("even_perks_welcome_carousel_paraTwo")}</p>
        <p className='!text-[11px] !w-[435px]'>{t("even_perks_welcome_carousel_paraThree")}</p>
      </div>,
      dynamicfooterStyles: "font-hanken-grotesk mb-[10%] modal-title text-[#94C3E8] text-[12px] font-[400]",

    },

  ];
  const slidesDataForNestedClimb = [
    {
      heading: addLineBreaks(t("Stay_covered_for_up_to_$100_when_you_need_it")),
      paragraph: <p>{t("Review_the_full_terms_here")} <span className='text-[#94C3E8] cursor-auto '>{t("here")}</span> </p>,
      imageUrl: require('./../../../assets/kudzu-plus-images/LearnMoreCarouselTrail/Enable_Overdraft_Protection-1.png')
    },
    {
      heading: addLineBreaks(t("Work_toward_unique_Savings_Goals")),
      paragraph: '',
      videoUrl: require('./../../../assets/videos/freeTrailVideos/Set_Intentions.mp4')
    },
    {
      heading: t("And_Even_More_Kudzu+_Perks"),
      paragraph: (t('Unlock_a_higher_interes_savings_Annual_Percentage_Yield_(APY)')),
      imageUrl: require('./../../../assets/kudzu-plus-images/welcom-carousel/And-Even-More.png'),
      dynamicSubHeaderStyles: "sm:w-[450px] font-hanken-grotesk modal-title text-white lg:text-[16px] md:text-[14px] sm:text-[10px] text-[12px]  font-[300]"
    },
  ];

  const slidesDataForChangePin = [
    {
      heading: addLineBreaks(t("Enjoy_unlimited_fee-freeo_ut-of-network")),
      paragraph: (t('Withdraw_funds_from_any_ATM')),
      imageUrl: require('./../../../assets/kudzu-plus-images/LearnMoreCarouselTrail/Enjoy_Fee-Free_ATM-1.png'),
      footerText: t("Monthly_Deducted_text")
    },
    {
      heading: t("Enjoy_Access_to_Additional_Kudzu+"),
      paragraph: (t('Including_a_high-yield_savings_APY')),
      imageUrl: require('./../../../assets/kudzu-plus-images/welcom-carousel/And-Even-More.png'),
    },

  ];

  const slidesDataForCoveredKudzu = [
    {
      heading: promoKey == PAID_PROMO_KEY ? addLineBreaks(t("Rest_assured_We’ll_cover_insufficient")) : addLineBreaks(t("Stay_covered_for_up_to_$100_when_you_need_it")),
      paragraph: promoKey == PAID_PROMO_KEY ? <p>{t("Read_full_terms_here")} <span className='text-[#94C3E8] cursor-auto '>{t("here")}</span> </p> : (t('Do_more_with_your_money_with')),
      imageUrl: require('./../../../assets/kudzu-plus-images/welcom-carousel/spendin-saving.png'),
      footerText: promoKey == PAID_PROMO_KEY ? t("Monthly_Deducted_text") : t("*A_$4.95_per_month_after_the_first_3_months_Cancel_anytime")
    },
    {
      heading: addLineBreaks(t("Plus_more_exclusive_Kudzu+_Perks")),
      paragraph: (t('Including_a_higher_interest_savings_APY')),
      imageUrl: require('./../../../assets/kudzu-plus-images/welcom-carousel/And-Even-More.png')
    },

  ];

  const slidesDataForClimbTouchPoints = [
    {
      heading: addLineBreaks(t("Work_toward_unique_Savings_Goals")),
      paragraph: promoKey == PAID_PROMO_KEY ? "" : (t('Do_more_with_your_money_with')),
      videoUrl: require('./../../../assets/videos/freeTrailVideos/Set_Intentions.mp4'),
      footerText: promoKey == PAID_PROMO_KEY ? t("Monthly_Deducted_text") : t("*A_$4.95_per_month_after_the_first_3_months_Cancel_anytime")
    },
    {
      heading: t("And_Even_More_Kudzu+_Perks"),
      paragraph: (t('Unlock_a_higher_interes_savings_Annual_Percentage_Yield_(APY)')),
      imageUrl: require('./../../../assets/kudzu-plus-images/welcom-carousel/And-Even-More.png'),
    },

  ];


  const slidesDataForExtendFlow = [
    {
      heading: <> <p className='text-[#94C3E8] cursor-auto '>{t("Let’s_keep_growing")}</p>{addLineBreaks(t("Explore_all_the_featuresand_ benefits_Kudzu+"))}</>,
      paragraph: '',
      imageUrl: require('./../../../assets/kudzu-plus-images/add-even-new.png'),
      footerTextForUpgrade: addLineBreaks(t("climb_basic_user_home_footer_updated")),
      dynamicfooterStyles: "font-hanken-grotesk mt-[42px] modal-title text-[#94C3E8] text-[12px] font-[400]"

    },
    {
      heading: addLineBreaks(t("Access_direct_deposit_funds_extend")),
      paragraph: '',
      videoUrl: require('./../../../assets/videos/freeTrailVideos/kudzu-plus-ach.mp4'),
      footerTextForUpgrade: t("Access_Direct_footer_explore_carousel"),
      dynamicfooterStyles: "font-hanken-grotesk md:w-[454px] mt-[42px] modal-title text-[#94C3E8] text-[12px] font-[400] sm:w-[322px]"
    },
    {
      heading: addLineBreaks(t("save_int_extend")),
      paragraph: <p>
        {t("plan_future_para")}
        <span
          className="!text-[#94C3E8] lg:text-[17px] cursor-pointer relative inline-block"
          onClick={(e) => {
            e.stopPropagation();
            const tooltip = e.currentTarget.querySelector('.tooltip');
            if (!tooltip) return;

            const isVisible = tooltip.style.display === 'block';
            tooltip.style.display = isVisible ? 'none' : 'block';

            // Close the second tooltip if it's open
            const tooltipAPY = e.currentTarget.closest('p').querySelector('.tooltipAPY');
            if (tooltipAPY && tooltipAPY.style.display === 'block') {
              tooltipAPY.style.display = 'none';
            }

            if (!isVisible) {
              const handleClickOutside = (event) => {
                if (tooltip && !tooltip.contains(event.target)) {
                  tooltip.style.display = 'none';
                  document.removeEventListener('click', handleClickOutside);
                }
              };
              setTimeout(() => {
                document.addEventListener('click', handleClickOutside);
              }, 0);
            }
          }}
        >
          {addLineBreaks(t("Saving"))}
          <div
            className={`tooltip hidden w-[174px] font-[400] absolute left-1/2 -translate-x-1/2 top-[100%] mt-2
                                  p-[16px] bg-[#3C66FF] text-white text-[12px] rounded-xl
                                  shadow-lg z-10 cursor-pointer transition-all duration-1000 leading-snug`}
          >
            <div className="tooltip-arrow-comparion"></div>
            <span className="text-[14px]">{t('Savings_Goals')}</span> {t('SavingGoal_Tooltip')}
          </div>
        </span>{" "}
        <br></br>
        <span
          className="!text-[#94C3E8] lg:text-[17px] cursor-pointer relative inline-block"
        >
          {addLineBreaks(t("Goal"))}
          <div
            className={`tooltip hidden w-[174px] font-[400] absolute left-1/2 -translate-x-1/2 top-[100%] mt-2
                                  p-[16px] bg-[#3C66FF] text-white text-[12px] rounded-xl
                                  shadow-lg z-10 cursor-pointer transition-all duration-1000`}
          >
            <div className="tooltip-arrow-comparion"></div>
            <span className="text-[14px]">{t('Savings_Goals')}</span> {t('SavingGoal_Tooltip')}
          </div>
        </span>{" "}
        {t("para_saving_goals_sec_part")}{" "}
        <span
          className="!text-[#94C3E8] cursor-pointer relative inline-block"
          onClick={(e) => {
            e.stopPropagation();
            const tooltips = e.currentTarget.querySelector('.tooltipAPY');
            if (!tooltips) return;

            const isVisibleAPY = tooltips.style.display === 'block';
            tooltips.style.display = isVisibleAPY ? 'none' : 'block';

            // Close the first tooltip if it's open
            const tooltip = e.currentTarget.closest('p').querySelector('.tooltip');
            if (tooltip && tooltip.style.display === 'block') {
              tooltip.style.display = 'none';
            }

            if (!isVisibleAPY) {
              const handleClickOutside = (event) => {
                if (tooltips && !tooltips.contains(event.target)) {
                  tooltips.style.display = 'none';
                  document.removeEventListener('click', handleClickOutside);
                }
              };
              setTimeout(() => {
                document.addEventListener('click', handleClickOutside);
              }, 0);
            }
          }}
        >
          {t("para_saving_goals_third_part")}
          <div
            className={`tooltipAPY hidden w-[174px] font-[400] absolute left-1/2 -translate-x-1/2 top-[100%] mt-2
                                  p-[16px] bg-[#3C66FF] text-white text-[12px] rounded-xl
                                  shadow-lg z-10 cursor-pointer transition-all duration-1000 leading-snug`}
          >
            <div className="tooltip-arrow-comparion"></div>
            <strong className="text-[12px]">{t('APY')}</strong> {t('APY_Saving_goal')}
          </div>
        </span>
      </p>,
      dynamicSubHeaderStyles: "sm:w-[396px] font-hanken-grotesk modal-title text-white lg:text-[16px] md:text-[14px] sm:text-[10px] text-[12px]  font-[300]",
      videoUrl: require('./../../../assets/videos/freeTrailVideos/Set_Intentions.mp4'),
      footerTextForUpgrade: t("annual_footer_extend"),
      dynamicfooterStyles: "font-hanken-grotesk mt-[42px] modal-title text-[#94C3E8] text-[12px] font-[400]"
    },
    {
      heading: addLineBreaks(t("Rest_assured_We’ll_cover_insufficient_update")),
      paragraph: '',
      imageUrlAlter: require('./../../../assets/kudzu-plus-images/overdraft_imag.png'),
      footerTextForUpgrade: <>{t("covered_by_kudzu_climb_footer_new_one")} <span className="underline cursor-pointer" onClick={handleTermsClick}>{t('kudzu_navigate_link')}</span></>,
      dynamicfooterStyles: "font-hanken-grotesk w-[454px] mt-[42px] modal-title text-[#94C3E8] text-[12px] font-[400]"
    },
    {
      heading: addLineBreaks(t("Enjoy_Fee-Free")),
      paragraph: '',
      videoUrl: require('./../../../assets/videos/freeTrailVideos/kudzu-plus-atm.mp4'),
      footerTextForUpgrade: t("free_atm_footer"),
      dynamicfooterStyles: "font-hanken-grotesk mt-[42px] modal-title text-[#94C3E8] text-[12px] font-[400]"
    },
  ];




  const showAlertModalPlus = (showPlusModal, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage, carousel, isBorderNone, btn1BgColor, summaryParagraph, opacityValue, comparisonScreen, fullWidth, footerButtonEnable, allButtonsDisable, subHeadingForCarousel,gradientButton, largeImage, gradientButtonBackground) => {
    setShowPlusModal(showPlusModal)
    setHighlightMsg(highlightMsg)
    setheaderMsg(headerMsg)
    setSubHeaderMsg(subHeaderMsg)
    setBtn1Exists(btn1Exists)
    setBtn2Exists(btn2Exists)
    setBtn1Text(btn1Text)
    setBtn2Text(btn2Text)
    setBtn1TypeAcpt(btn1TypeAcpt)
    setModelImage(modelImage)
    setBtn1Exists(btn1Exists)
    setBtn1Text(btn1Text)
    setCarousel(carousel)
    setisBorderNone(isBorderNone)
    setBtn1BgColor(btn1BgColor)
    setSummaryParagraph(summaryParagraph)
    setOpacityValueLow(opacityValue)
    setComparisonScreen(comparisonScreen)
    setFullWidth(fullWidth)
    setFooterButtonEnable(footerButtonEnable)
    setAllButtonsDisable(allButtonsDisable)
    setSubHeadingForCarousel(subHeadingForCarousel)
    setGradientButton(gradientButton)
    setLargeImage(largeImage)
    setGradientButtonBackground(gradientButtonBackground)
  }
  // Define the switch case logic in a separate function


  const getButtonText = () => {
    switch (location.pathname) {
      case '/Settings/manageMembershipKudzuplus':
        return 'Back to Manage Membership';
      default:
        return 'Back to Home';
    }
  };

  const isBackModal = () => {
    setShowPlusModal(false);
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      showAlertModalPlus(
        true,
        '',
        '',
        "",
        true,
        true,
        promoKey == PAID_PROMO_KEY || loggedResponse?.ShowKudzuPlusPromoAfterCancellation === true ? t('get_started_With_kudzu_plus') : t('Begin_Free_3-Month_Trial'),
        t('No_Thanks'),
        true,
        '',
        <CustomCarousel slidesData={slidesDataForHome} />,
        true,
        "",
        "",
        true,
        "",
        false,
        false,
        false,
        false,
        false,
        ""
      );
    }, 500);

  }

  const handleKudzuFlow = (kudzuFlowFromVal) => {
    setLoading(true)
    setTimeout(() => {
      switch (kudzuFlowFromVal) {
        case t('savings_transfer_money'):
        case "fromAccountSpending":
        case "fromAccountSavings":
        case "fromATM":
        case "fromHelp":
        case "login":
        case t("setup_direct_Deposit"):
        case t('fromSignUp'):
          showAlertModalPlus(
            true,
            '',
            '',
            "",
            true,
            true,
            promoKey == PAID_PROMO_KEY || loggedResponse?.ShowKudzuPlusPromoAfterCancellation === true ? t('get_started_With_kudzu_plus') : t('Begin_Free_3-Month_Trial'),
            t('No_Thanks'),
            true,
            '',
            <CustomCarousel slidesData={slidesDataForHome} />,
            true,
            "",
            "",
            true,
            "",
            false,
            false,
            false,
            false,
            false,
            ""
          );
          break;
        case "fromMembership":
          showAlertModalPlus(
            true,
            '',
            '',
            "",
            true,
            true,
            promoKey == PAID_PROMO_KEY || loggedResponse?.ShowKudzuPlusPromoAfterCancellation === true ? t('get_started_With_kudzu_plus') : t('Begin_Free_3-Month_Trial'),
            t('No_Thanks'),
            true,
            '',
            <CustomCarousel slidesData={slidesDataForHome} />,
            true,
            "",
            "",
            true,
            "",
            false,
            false,
            false,
            false,
            false,
            ""
          );
          break;
        case "Climb":
          showAlertModalPlus(
            true,
            '',
            '',
            "",
            true,
            true,
            t('skip'),
            t('Learn_More'),
            true,
            '',
            <CustomCarousel slidesData={slidesDataForClimb} isClimbMenu={true} dotsAbove={true} onCancelBtnClickPlusModal={onCancelBtnClickPlusModal} forClimbBtn={true} forClimbHomeBtn={true} climNextCallBack={acceptHandleForClimb} finalButtontextChange={t('done')} />,
            true,
            "",
            "",
            true,  //opacityValue
            "",
            false,  // fullwidth
            true,  // footer button value
            true,
            false,
            false,
            ""
          );
          break;

        case "Saving":
          showAlertModalPlus(
            true,
            '',
            '',
            "",
            true,
            true,
            t('skip'),
            t('Learn_More'),
            true,
            '',
            <CustomCarousel slidesData={slidesDataForClimb} dotsAbove={true} forClimbBtn={true} forClimbHomeBtn={true} />,
            true,
            "",
            "",
            false,
            "",
            false,  // fullwidth
            true,  // footer button value
            true,
            false,
            false,
            ""
          );
          break;

        case "ClimbNestedData":
          showAlertModalPlus(
            true,
            '',
            '',
            "",
            true,
            true,
            t('skip'),
            t('Learn_More'),
            true,
            '',
            <CustomCarousel slidesData={slidesDataForNestedClimb} dotsAbove={true} forClimbBtn={true} forClimbHomeBtn={true} />,
            true,
            "",
            "",
            false,
            "",
            false,  // fullwidth
            true,  // footer button value
            true,
            false,
            false,
            ""
          );
          break
        case "climFooter":
          showAlertModalPlus(
            true,
            '',
            '',
            "",
            true,
            true,
            t('skip'),
            t('Learn_More'),
            true,
            '',
            <CustomCarousel slidesData={slidesDataForClimbTouchPoints} onCancelBtnClickPlusModal={onCancelBtnClickPlusModal} dotsAbove={true} finalButtontextChange={''} forClimbBtn={true} footerbtnContent={true} climNextCallBack={acceptHandleForClimb} />,
            true,
            "",
            "",
            true,
            "",
            false,  // fullwidth
            true,   // footer button value
            true,
            false,
            false,
            ""
          );
          break;
        case t('change_pin_success'):
          showAlertModalPlus(
            true,
            '',
            '',
            "",
            true,
            true,
            t('skip'),
            t('Learn_More'),
            true,
            '',
            <CustomCarousel slidesData={slidesDataForChangePin} onCancelBtnClickPlusModal={onCancelBtnClickPlusModal} dotsAbove={true} finalButtontextChange={t('start_trial')} forClimbBtn={true} footerbtnContent={true} />,
            true,
            "",
            "",
            true,
            "",
            false,  // fullwidth
            true,   // footer button value
            true,
            false,
            false,
            ""
          );
          break;
        case "climbCoveredByKudzu":
          showAlertModalPlus(
            true,
            '',
            '',
            "",
            true,
            true,
            t('skip'),
            t('Learn_More'),
            true,
            '',
            <CustomCarousel slidesData={slidesDataForCoveredKudzu} onCancelBtnClickPlusModal={onCancelBtnClickPlusModal} dotsAbove={true} finalButtontextChange={''} forClimbBtn={true} footerbtnContent={true} climNextCallBack={acceptHandleForClimb} />,
            true,
            "",
            "",
            true,
            "",
            false,  // fullwidth
            true,   // footer button value
            true,
            false,
            false,
            ""
          );
          break;
        case t("fromExtendFlow"):
          setKudzuCheck(true);
          showAlertModalPlus(
            true,
            '',
            '',
            "",
            true,
            true,
            t('Extend_Membership'),
            getButtonText(),
            true,
            '',
            <CustomCarousel slidesData={slidesDataForExtendFlow} />,
            true,
            "",
            "",
            true,
            "",
            false,
            false,
            false,
            true,
            false,
            ""
          );

          break;
        case t("featureCarousel"):

          break;

        case t('Begin_Free_3-Month_Trial'):
          break;

        // Add more cases as needed
        default:
          // Optional default case
          break;
      }
      setLoading(false)
    }, 1000);

  };

  useEffect(() => {
    handleKudzuFlow(kudzuFlowFromVal);
  }, [kudzuFlowFromVal]);


  useEffect(() => {
    handleKudzuFlow(kudzuFlowFromVal);
  }, []);

  useEffect(() => {

    return () => {
      dispatch({ type: 'CLIMB_POPUP_SHOWVALUE', payload: { climbPopShowValue: false } });
    }
  }, [dispatch]);



  const handleCarousels = () =>{
     showAlertModalPlus(
                true,
                '',
                '',
                "",
                true,
                true,
                isSignUpKudzuplusTrialVal ? t('Begin_Free_3-Month_Trial') : t('get_started_With_kudzu_plus'),
                t('No_Thanks'),
                true,
                '',
                <CustomCarousel slidesData={slidesDataForHome} />,
                true,
                "",
                "",
                true,
                "",
                false,
                false
              );
  }



  const acceptHandleForClimb = () => {
    showAlertModalPlus(false)
    setLoading(true)
    setTimeout(() => {
      showAlertModalPlus(true, '', promoKey == PAID_PROMO_KEY || loggedResponse?.ShowKudzuPlusPromoAfterCancellation === true
        ? t('access_exclusive_features_and_benefits_with_kudzu_membership') : t('Access_exclusive_features_and_benefits'), "", false, false, '', '', false, '', "", true, "", "", true, <ComparisonOffer handleComparisonScreen={isSignUpAccept} />, true, false);
      setLoading(false)
    }, 1000);
    logFirebaseEvents("Membership_Enrollment", "Kudzu_Plus_Begin_Free_Trial_Clicked", "Kudzu_Plus_Begin_Free_Trial_Clicked", "", "");
  }




  const onAcptBtnClickPlusModal = () => {
    debugger;
    if (kudzuFlowFromVal === t("fromExtendFlow")) {
      showAlertModalPlus(false)
      setLoading(true)
      setTimeout(() => {
        showAlertModalPlus(true, '', <><span className='text-[#94C3E8] cursor-auto '>{t("Awesome")}</span> {t("Please_confirm_your_Kudzu+_membership")}</>, "", true, true, t('confirm_extension'), getButtonText(), true, require('./../../../assets/kudzu-plus-images/KudzuPluseLogo.png'), "", true, "", t('monthly_memebership_fee_will_be_automatically_deducted'), true, "", false, false, false, true, true, "linear-gradient(to right, #2965FB, #4B70B9, #30BC89)");
        setLoading(false)
      }, 1000);
      const data = { kudzuFlowFrom: "" };
      dispatch({ type: 'KUDZU_PLUS_FROM', payload: data });
      const extendData = { fromExtendFlow: true };
      dispatch({ type: 'FROM_EXTEND_FLOW', payload: extendData });
    }
    else if (btn1Text == t('confirm_extension')) {
      setLoading(true)
      setTimeout(() => {
        navigate("/kudzuplusSecurity", { state: { type: t('upgrade_to_kduzu_plus') } })
        setLoading(false)
      }, 1000);
    }
    else {
      showAlertModalPlus(false)
      setLoading(true)
      setTimeout(() => {
        // change for comparision screen 
        showAlertModalPlus(true, '', promoKey == PAID_PROMO_KEY || loggedResponse?.ShowKudzuPlusPromoAfterCancellation === true
          ? addLineBreaks(t('access_exclusive_features_and_benefits_with_kudzu_membership')) : addLineBreaks(t('Access_exclusive_features_and_benefits')), "", false, false, '', '', false, '', "", true, "", "", true, 
          <ComparisonOffer handleComparisonScreen={isSignUpAccept} preLoginAgreement={handlePreLoginAgreement} />, true, false, false,<> <p className={`${SubHeaderMsgStylesPlus}  mt-6`}>{t('Get_access_to_more_with_a_Kudzu+_membership')}</p><p className={HighlightMsgStylesPlus} onClick={handleCarousels}>{t('learn_more')}</p></>);
        setLoading(false)
      }, 1000);
      logFirebaseEvents("Membership_Enrollment", "Kudzu_Plus_Begin_Free_Trial_Clicked", "Kudzu_Plus_Begin_Free_Trial_Clicked", "", "");
    }
  }


  const onCancelBtnClickPlusModal = () => {
    setLoading(true)
    setTimeout(() => {
      if (expiredFlow) {
        const tooltipCookieNameForHome = `expiredFlow${cards[0].ExternalSVAID}`;
        Cookies.set(tooltipCookieNameForHome, "true", { expires: 1825 });
      }
      setShowPlusModal(false);
      setLoading(false)
    }, 1000);
    logFirebaseEvents("Membership_Enrollment", "Membership_Enrollment_Kudzu_Plus_No_Thanks_Clicked", "Membership_Enrollment_Kudzu_Plus_No_Thanks_Clicked", "", "");
    dispatch({ type: 'CLIMB_POPUP_SHOWVALUE', payload: { climbPopShowValue: false } });
    if (kudzuFlowFromVal === t('change_pin_success')) {
      navigate('/CardServices/CardActionScreen')
    }
    else if (kudzuFlowFromVal === t('savings_transfer_money')) {
      logFirebaseEvents('Savings' + "_" + "Transfer_Money", 'Savings' + "_" + "Back_To_Account_Services_Clicked", "Back_To_Account_Services_Clicked", "", "");
      navigate('/AccountServices/Savings');
    }
  }


  const closeModel = () => {
    setLoading(true)
    setTimeout(() => {
      if (extendFlowCloseCallbackFunction) {
        extendFlowCloseCallbackFunction(false)
      }
      if (expiredFlow) {
        const tooltipCookieNameForHome = `expiredFlow${cards[0].ExternalSVAID}`;
        Cookies.set(tooltipCookieNameForHome, "true", { expires: 1825 });
      }
      setShowPlusModal(false)
      setLoading(false)
    }, 1000);
    dispatch({ type: 'CLIMB_POPUP_SHOWVALUE', payload: { climbPopShowValue: false } });
    if (SignUpKudzuplusTrue) {
      isSignUpCancel();
    }
    if (kudzuFlowFromVal === t('change_pin_success')) {
      navigate('/CardServices/CardActionScreen')
    }
    else if (kudzuFlowFromVal === t('savings_transfer_money')) {
      logFirebaseEvents('Savings' + "_" + "Transfer_Money", 'Savings' + "_" + "Back_To_Account_Services_Clicked", "Back_To_Account_Services_Clicked", "", "");
      navigate('/AccountServices/Savings');
    }
  };



  return (
    <>
    <div>
      
  <CustomModalPlus isOpen={showPlusModal} onClose={closeModel} onBack={() => {
    if (SignUpKudzuplusTrue) {
      isBackModal();
    }
    else if (kudzuFlowFromVal) {
      handleKudzuFlow(kudzuFlowFromVal)
    } else {
      closeModel();
    }
  }}
    image={modelImage}
    carousel={carousel}
    comparisonScreen={comparisonScreen}
    summaryParagraph={summaryParagraph ? <p style={{ color: "#94c3e8" }} className={summaryParagraphStyles}>{summaryParagraph}</p> : ""}
    isBorderNone={isBorderNone}
    highlightMsg={<p className={HeaderMsgStyles}> {headerMsg}</p>}
    subHeaderMsg={subHeaderMsg ? <p className={SubHeaderMsgStyles}>{subHeaderMsg}</p> : ""}
    btn1Exists={btn1Exists}
    btn2Exists={btn2Exists}
    btn1Text={btn1Text}
    btn1BgColor={btn1BgColor}
    btn2Text={btn2Text}
    opacityLow={opacityValueLow}
    defaultCornerRadius={false}
    btn1TypeAcpt={btn1TypeAcpt}
    fullWidth={fullWidth}
    btn2TextColor={'#779CE5'}
    onAcptBtnClick={onAcptBtnClickPlusModal}
    onCancelBtnClick={() => {
      if (SignUpKudzuplusTrue) {
        isSignUpCancel();
      } else {
        onCancelBtnClickPlusModal();
      }
    }}
    footerButtonEnable={footerButtonEnable}
    allButtonsDisable={allButtonsDisable}
    subHeadingForCarousel={subHeadingForCarousel}
    gradientButton={gradientButton}
    largeImage={largeImage}
    gradientBtnBackground={gradientButtonBackground}
    gradientBtnCheckExtend={kudzuCheck}
  />
    
      

      {loading && <Loader />}
      
    </div>
    <Suspense fallback={<div>Loading...</div>}>
    <Modal
  isIframe={true}
  isOpen={showAgreementsModel}
  onClose={() => {
    setShowAgreementsModel(false);
  }}
  title={false}
  content={
    <div
      className="w-full h-full   md:pt-0 sm:pt-6  pt-16"
      style={{ height: window.innerHeight }}
    >
      <iframe
        src={policyURL}
        id="policyIframe"
        title="Embedded Website"
        className="w-full"
        style={{ height: window.innerHeight }}
      />
    </div>
  }
/>
</Suspense>


</>

  )
}
export default MemnershipEnrollmentScreens